<template>
  <!-- 投资详情底部 -->
  <div class="InstitutionalInvestorBottom main">
    <DockingSystemTitle
      :title="'投后项目展示'"
      :moreType="false"
      :underlineType="false"
      :titleCenter="false"
    />
    <div class="content">
      <el-row class="contentNav" type="flex" justify="space-around">
        <el-col class="contentTitle" :xs="8" :sm="4">公司</el-col>
        <el-col class="contentTitle hidden-xs-only" :xs="0" :sm="4">金额</el-col>
        <el-col class="contentTitle" :xs="8" :sm="4">行业</el-col>
        <el-col class="contentTitle hidden-xs-only" :xs="0" :sm="4">阶段</el-col>
        <el-col class="contentTitle" :xs="8" :sm="4">时间</el-col>
      </el-row>
      <el-row class="contentUl" type="flex" justify="space-around"  v-for="(item,index) in msg.show" :key="index">
        <el-col class="contentLi" :xs="8" :sm="4">{{item.companyname}}</el-col>
        <el-col class="contentLi hidden-xs-only" :xs="0" :sm="4">{{item.money}}</el-col>
        <el-col class="contentLi" :xs="8" :sm="4">{{item.industry}}</el-col>
        <el-col class="contentLi hidden-xs-only" :xs="0" :sm="4">{{item.stage}}</el-col>
        <el-col class="contentLi" :xs="8" :sm="4">{{item.time}}</el-col>
      </el-row>
    
    </div>
   
  </div>
</template>

<script>
import DockingSystemTitle from "@/components/DockingSystem/Title/DockingSystemTitle.vue"; //投资机构详情的头部nav
export default {
  props: {
    msg:Object
  },
  components: {
    DockingSystemTitle,
  },
  data() {
    return {

     
    };
  },
  created: function () {},
  methods: {},
};
</script>

<style scoped>
@media (max-width: 768px) {
  .InstitutionalInvestorBottom .content{
    margin: 0 15px;
  }
}
.InstitutionalInvestorBottom {
  margin-top: 40px;
  background-color: #262525;
  border-radius: 25px;
  margin-bottom: 55px;
}
.content{
    margin: 0 30px;
}
.contentNav{
    padding-top: 37px;
    padding-bottom: 17px;
    border-bottom: 1px solid #373736;
}

.contentTitle{
    text-align: center;
    
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 28px;
	letter-spacing: 0px;
	color: #fff;
}
.contentUl{
    padding: 40px 0;
    border-bottom: 1px solid #373736;
}
.content .contentUl:last-child{
    border-bottom: none;

}
.contentLi{
    text-align: center;
    
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 28px;
	letter-spacing: 0px;
	color: #BFBFBF;
}
</style>